import { Close } from "@material-ui/icons";
import { Button, IconButton } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { saveAs } from "file-saver";
import { useSnackbar } from "notistack";
import { InboundApi } from "service/api/inbound.api";
import { QUERY_KEYS } from "service/constant/query-keys";
import { downloadFileByUrl } from "ultis/common";

export const useGetLogInboundCalls = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.INBOUND_CALL_LOGS, params],
    queryFn: async () => {
      const res = await InboundApi.getLogInboundCalls(params);
      return res.data?.data;
    },
    ...options,
  });
};

export const useExportLogInboundCalls = (params, options, onClickView) => {
  const newParams = { ...params, exportReport: true };
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  return useQuery({
    queryKey: [QUERY_KEYS.INBOUND_CALL_LOGS_EXPORT, newParams],
    queryFn: async () => {
      await InboundApi.getLogInboundCalls(newParams);
      enqueueSnackbar(
        "Đã xuất cáo! Vui lòng truy cập lịch sử xuất báo cáo để tải file",
        {
          variant: "success",
          autoHideDuration: 15000,
          action: (snackbarKey) => (
            <>
              <Button
                variant="text"
                onClick={() => {
                  closeSnackbar(snackbarKey);
                  onClickView();
                }}
                sx={{ fontSize: 13, fontWeight: 700 }}
                color="inherit">
                Xem tại đây
              </Button>
              <IconButton
                onClick={() => closeSnackbar(snackbarKey)}
                color="inherit">
                <Close />
              </IconButton>
            </>
          ),
        }
      );
    },
    enabled: false,
    ...options,
  });
};

export const useGetListInboundCall = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.INBOUND_CALL_LIST, params],
    queryFn: async () => {
      const res = await InboundApi.getListInboundCall(params);
      return res.data;
    },
    ...options,
  });
};

export const useGetListNumberPbx = (options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.LIST_NUMBER_PBX],
    queryFn: async () => {
      const res = await InboundApi.getListNumberPbx();
      return res.data;
    },
    ...options,
  });
};

export const useGetCountListInboundCall = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.INBOUND_CALL_LIST_COUNT, params],
    queryFn: async () => {
      const res = await InboundApi.getCountListInboundCall(params);
      return res.data.count;
    },
    ...options,
  });
};

export const useExportListInboundCall = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.INBOUND_CALL_LIST_EXPORT, params],
    queryFn: async () => {
      const res = await InboundApi.exportListInboundCall(params);
      const fileUrl = res.data?.fileUrl;
      if (fileUrl) {
        downloadFileByUrl(fileUrl);
      }
    },
    ...options,
  });
};

export const useExportGetReportCallMeDingdong = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.REPORT_CALL_ME_DINGDONG, params],
    queryFn: async () => {
      const res = await InboundApi.getReportCallMeDingdong(params);
      console.log("🚀  res ==", res);
      const linkFile = res.data?.fileUrl;
      if (linkFile) {
        const fileName = linkFile.split("/").pop();
        saveAs(linkFile, fileName);
      }
    },
    ...options,
  });
};
